import type { AnalyticsReportData } from '../types'
import { extractPrimitiveValue } from './extractPrimitiveValue'

type GetSummaryValueParams = {
  reportData: AnalyticsReportData | undefined
  columnKey: string | undefined
}

export const getSummaryValue = ({ reportData, columnKey }: GetSummaryValueParams): number => {
  if (!reportData || !columnKey) return 0

  const summary = reportData.report.summary as AnalyticsReportData['report']['summary']
  if (!summary || !(columnKey in summary)) return 0

  const summaryValue = summary[columnKey]
  const primitiveValue = extractPrimitiveValue(summaryValue)

  return typeof primitiveValue === 'number' ? primitiveValue : 0
}
